import * as Yup from "yup";
import { createValidationRule } from "../../../commonComponent/validation/validation";

const ageValidation = Yup.mixed().test('is-valid-age', 'Age must be a number between 1 and 150', value => {
  if (typeof value === 'number') {
    return value >= 1 && value <= 150;
  }
  return true; // Allow strings
});

export const addEditPatientValidation = Yup.object().shape({
firstName: createValidationRule("string"),
primary_phone_number: createValidationRule("phone")
});


